<template>
  <hic-dialog append-to-body :close-on-click-modal="false" :visible="visible" width="50%" :title="`角色（${role.name}）成员选择`" @close="close" @open="open">
    <el-row type="flex" justify="space-around" align="middle">
      <el-checkbox v-model="condition.onlyMember" :disabled="searchLoading" @change="queryStaff">隐藏非成员</el-checkbox>
      <el-select clearable style="width: 40%" @change="queryStaff" v-model="condition.deptCode" placeholder="请选择科室" size="mini">
        <el-option v-for="item in dict.Dept" :key="item.code" :label="item.name" :value="item.code"></el-option>
      </el-select>
      <el-input style="width: 40%" v-model="condition.keyword" placeholder="请输入姓名" size="mini" v-on:keyup.enter.native="queryStaff(1)">
        <el-button :loading="searchLoading" slot="append" icon="el-icon-search" @click="queryStaff(1)"></el-button>
      </el-input>
    </el-row>
    <el-skeleton v-if="searchLoading" animated class="top-pad left" />
    <el-checkbox-group v-else v-model="checkList" style="height: 15rem">
      <el-row v-if="members.items.length">
        <el-col :span="6" :key="item.id" v-for="item in members.items" style="padding: 1.5rem 0 0 1.5rem; text-align: left">
          <el-checkbox class="item" :label="item.id" @change="checkedChange(item.id)" :title="item.id">{{ item.name || item.name }}</el-checkbox>
        </el-col>
      </el-row>
    </el-checkbox-group>
    <br />
    <br />
    <hic-paging :entities="members" :condition="condition" @load="queryStaff" layout="total, prev, pager, next" />
  </hic-dialog>
</template>
<script>
  import api from "./api.js";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      role: Object,
    },
    data() {
      return {
        deptList: [],
        checkList: [],
        members: {
          items: [],
        },
        condition: {
          onlyMember: true,
          deptCode: null,
          keyword: null,
          pageSize: 20,
          pageIndexOnView: 1,
        },
        searchLoading: false,
      };
    },
    computed: {
      ...mapGetters(["dict"]),
    },
    created() {
      this.open();
    },
    methods: {
      open() {
        let _this = this;
        this.queryStaff();
        // 获取所有成员
        api
          .Role.queryStaff(this.role.code, {
            pageSize: 0,
            pageIndexOnView: 1,
          })
          .then((res) => {
            _this.checkList = res.items.map((item) => {
              return item.id;
            });
          });
          
      },
      queryStaff() {
        let _this = this;
        this.searchLoading = true;
        (() => {
          if (this.condition.onlyMember) {
            return api.Role.queryStaff(this.role.code, this.condition);
          } else {
            return api.Staff.query(this.condition);
          }
        })()
          .then((res) => {
            _this.members = res;
          })
          .finally(() => {
            this.searchLoading = false;
          });
      },
      close() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      checkedChange(id) {
        // 控件已经自动先修改了 checkList，所以不要设置
        if (this.checkList.indexOf(id) == -1) {
          api.Staff.delRole(id, this.role.code).then((res) => {
            this.$message.success("角色删除成功");
          });
         
        } else {
          api.Staff.addRole(id, this.role.code).then((res) => {
            this.$message.success("用户角色添加成功");
          });
        }
      },
    },
  };
</script>
